export default "__VITE_ASSET__Yzfs5k3B__"